import { useState } from 'react';
import { Table } from '../Table';
import { WaterButNoCoffee } from '../WaterButNoCoffee';
import { CoffeeButNoWater } from '../CoffeeButNoWater';
import { Settings } from '../Settings';

export const App = () => {
  const [ratio, setRatio] = useState(17);
  const [cupSize, setCupSize] = useState(125);
  const [customRatio, setCustomRatio] = useState('');

  return (
    <>
      <header>
        <h1>Kaffkulator</h1>
      </header>
      <main>
        <Settings
          customRatio={customRatio}
          setCustomRatio={setCustomRatio}
          cupSize={cupSize}
          setCupSize={setCupSize}
          setRatio={setRatio}
        />
        <WaterButNoCoffee ratio={ratio} />
        <CoffeeButNoWater ratio={ratio} />
        <Table cupSize={cupSize} ratio={ratio} />
      </main>
      <footer>
        <p>☕️</p>
      </footer>
    </>
  );
};
